import Survey from './manage';
export default Survey;
